import UltMeta, { Meta } from "./UltMeta/index";
//数据来源
class dataSourceStatus extends UltMeta {
    ADMIN = new Meta(0, "供应链端");
    CUSTOMER = new Meta(1, "客户端");
}
export const DATA_SOURCE_STATUS = new dataSourceStatus();

class PerformanceStatus extends UltMeta {
    START = new Meta(1, "发车");
    ABNORMAL = new Meta(2, "异常信息");
    END = new Meta(3, "卸货");
    CANCEL = new Meta(4, "运单取消");
}

export const PERFORMANCE_STATUS = new PerformanceStatus();

class State extends UltMeta {
    WAITING_TO_GO = new Meta(1, "待发车");

    DEPARTED = new Meta(2, "已发车");

    UNLOADED = new Meta(3, "已卸货");

    CANCELED = new Meta(4, "已取消");
}

export const TRANSPORT_ORDER_VEHICLE_STATE = new State();

class FreightType extends UltMeta {
    DISCUSSION = new Meta(1, "电议");

    ONE_SET_PRICE = new Meta(2, "一口价");
}

export const FREIGHT_TYPE = new FreightType();

class FreightUnitPriceType extends UltMeta {
    TRIP = new Meta(1, "元/趟");

    TON = new Meta(2, "元/吨");

    SQUARE = new Meta(3, "元/方");

    PIECE = new Meta(4, "元/件");
    constructor(unit?: string) {
        super();
        if(unit){
            this.TON = new Meta(2, `元/${unit}`);
        }
    }
}

export const FREIGHT_UNIT_PRICE_TYPE = (unit?: string) => {
    return new FreightUnitPriceType(unit);
};

class CarType extends UltMeta {
    DUMP = new Meta(1, "自卸车");
    HIGH = new Meta(2, "高栏");
    FENCE = new Meta(3, "栏板");
    VAN = new Meta(4, "厢式");
    FLAT = new Meta(5, "平板");
    TANK = new Meta(6, "罐车");
    CONCRETE = new Meta(7, "混凝土车");
    SEDAN = new Meta(8, "轿运车");
    CONTAINER = new Meta(9, "集装箱");
    REFRIGERATED = new Meta(10, "冷藏");
    OTHER = new Meta(11, "其他");
}
export const CAR_TYPE = new CarType();

class VehicleLongType extends UltMeta {
    LENGTH_17_5 = new Meta(1, "17.5米");
    LENGTH_16_5 = new Meta(2, "16.5米");
    LENGTH_15_0 = new Meta(3, "15米");
    LENGTH_13_75 = new Meta(4, "13.75米");
    LENGTH_13_5 = new Meta(5, "13.5米");
    LENGTH_13_0 = new Meta(6, "13.0米");
    LENGTH_12_5 = new Meta(7, "12.5米");
    LENGTH_9_6 = new Meta(8, "9.6米");
    LENGTH_7_2 = new Meta(9, "7.2米");
    LENGTH_6_8 = new Meta(10, "6.8米");
    LENGTH_5_2 = new Meta(11, "5.2米");
    LENGTH_4_2 = new Meta(12, "4.2米");
}
export const VEHICLE_LONG_TYPE = new VehicleLongType();

/**
 * 数据来源
 */
class Source extends UltMeta {
    OFFLINE = new Meta(2, "线下单据");
    SELF_LIFT = new Meta(1, "自建录入");
}
export const SOURCE = new Source();
